import React from 'react'
import categoryIconMap from 'sprites/pds-icons.json'

type CategoryIconMap = {
  [key: string]: string[] | undefined
}

interface SvgPdsIconProps {
  className?: string
  categoryId: string
}

export function SvgPdsIcon({ className, categoryId }: SvgPdsIconProps): JSX.Element | null {
  const icon = (categoryIconMap as CategoryIconMap)[categoryId]

  if (!icon) {
    console.warn(`Icon is missing for category ID: ${categoryId}`)
    return null
  }

  const [name, color] = icon

  return (
    <svg className={className} width="100%" height="100%">
      <use href={`#${name}`} fill={color} />
    </svg>
  )
}

interface SvgPdsMarkerIconProps {
  className?: string
  style?: React.CSSProperties
  width?: string
  height?: string
  categoryId: string
  innerColor: string
}

export function SvgPdsMarkerIcon({
  className,
  style,
  categoryId,
  innerColor,
  width = '100%',
  height = '100%',
}: SvgPdsMarkerIconProps): JSX.Element | null {
  const icon = (categoryIconMap as CategoryIconMap)[categoryId]

  if (!icon) {
    console.warn(`Icon is missing for category ID: ${categoryId}`)
    return null
  }

  const [name, _] = icon

  return (
    <SvgMarkerIcon className={className} style={style} width={width} height={height}>
      <use href={`#${name}`} height={16} y={10} fill={innerColor} />
    </SvgMarkerIcon>
  )
}

interface SvgMarkerIconProps {
  className?: string
  style?: React.CSSProperties
  width?: string
  height?: string
  children?: React.ReactNode
}

export function SvgMarkerIcon({
  children,
  className,
  style,
  width = '100%',
  height = '100%',
}: SvgMarkerIconProps): JSX.Element {
  // "xmlns" prop is not needed for React but is needed for JSLA
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      width={width}
      height={height}
      viewBox="0 0 34 45"
      fill="none"
      cursor="pointer"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 43C14.79 43 13 43.4475 13 44C13 44.552 14.79 45 17 45C19.21 45 21 44.552 21 44C21 43.4475 19.21 43 17 43Z"
        fill="#233459"
        fillOpacity="0.35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.5 17.1727C33.5 7.97807 26.0831 0.5 16.9846 0.5C7.89161 0.5 0.5 7.97245 0.5 17.1727L0.505968 17.9154L0.51362 18.2794C0.677404 24.6672 2.37734 28.8577 8.77193 35.3756L16.9838 43.7118L25.2291 35.3746C31.7434 28.7347 33.3851 24.5099 33.494 17.9154L33.5 17.1727ZM1.00304 16.8544C1.17108 8.06936 8.28042 1 16.9846 1C25.7936 1 33 8.24074 33 17.1727L32.9933 18.3576L32.9896 18.5593C32.9041 22.674 32.1158 27.6095 24.8683 35.0276L16.9846 43L9.13174 35.0276C1.40904 27.1231 1.02026 22.0374 1.00099 17.76L1.00304 16.8544Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9846 43L9.4934 35.3944C1.05417 26.9109 1 21.6387 1 17.1727C1 8.24074 8.17555 1 16.9846 1C25.7936 1 33 8.24074 33 17.1727C33 21.6387 32.9459 26.9109 24.5066 35.3944L16.9846 43Z"
      />

      {children}

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33 17.1727C33 8.24074 25.7936 1 16.9846 1C8.17555 1 1 8.24074 1 17.1727C1 21.6387 1.05417 26.9109 9.4934 35.3944L16.9846 43L24.8683 35.0276C31.6405 28.096 32.773 23.3319 32.9621 19.3798L32.9788 18.9667L32.9933 18.3576L33 17.1727ZM2 17.1727C2 8.79725 8.72371 2 16.9846 2C25.2519 2 32 8.80375 32 17.1727L31.9933 18.3519L31.9863 18.6794C31.8369 24.1112 30.0766 28.2658 24.153 34.3288L16.985 41.576L9.84798 34.3306C3.38006 27.7406 2 23.8285 2 17.1727Z"
        fill="#233459"
        fillOpacity="0.35"
      />
    </svg>
  )
}
